import { useEffect, useState } from 'react'
import { usePostHog } from '@posthog/react'

/**
 * True once the client `/flags` call has resolved, so a flag reading of
 * `undefined` can be trusted as "not bucketed" rather than "not loaded yet".
 *
 * posthog-js invokes `onFeatureFlags` when `/flags` fails as well (with
 * `errorsLoading`), and immediately when flags are already loaded, so this
 * never stalls on a failed or earlier fetch. A client that never initialised
 * (PostHog disabled, no key) will never report flags, so it counts as ready.
 *
 * Starts false and only flips inside an effect, so the server render and the
 * first client render agree.
 */
// eslint-disable-next-line import/prefer-default-export
export const useFeatureFlagsReady = (): boolean => {
  const client = usePostHog()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!client?.__loaded) {
      setReady(true)
      return undefined
    }
    return client.onFeatureFlags(() => setReady(true))
  }, [client])

  return ready
}
